<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 4H3a1 1 0 00-1 1v13a1 1 0 001 1h5v1H7a1 1 0 000 2h10a1 1 0 000-2h-1v-1h5a1 1 0 001-1V5a1 1 0 00-1-1zm-1 2v8H4V6zm-5 14H9v-1h6zM4 17v-2h16v2z"/></svg>